<template>
  <div class="sso-login-button">
    <DpplGoogleLinkedinButton
      class="sso-button w-100"
      color="primary"
      variant="outlined"
      :active="isActive"
      :title="ssoButtonText"
      @click="onSsoClick"
    >
      {{ ssoButtonText }}
    </DpplGoogleLinkedinButton>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getLocalStorageObject } from '@/helpers/localStorage';
import { redirectToSsoProvider } from '@/helpers/redirect';
import DpplGoogleLinkedinButton from '@/components/datapeople/DpplGoogleLinkedinButton.vue';

const router = useRouter();

defineProps({
  isActive: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleSso']);

const lastSsoProvider = ref('');
const lastSsoName = ref('');
const lastSsoIsGoogle = ref(false);
const lastSsoIsMicrosoft = ref(false);

const ssoButtonText = computed(() => (
  lastSsoProvider.value
    ? (lastSsoName.value.replaceAll('_', ' ') || lastSsoProvider.value)
    : 'Single Sign-On'
));

onMounted(() => {
  const {
    provider, name, isGoogle, isMicrosoft,
  } = getLocalStorageObject({ key: 'lastSso' }) || {};

  if (provider) {
    lastSsoProvider.value = provider;
    lastSsoName.value = name || provider;
    lastSsoIsGoogle.value = isGoogle;
    lastSsoIsMicrosoft.value = isMicrosoft;
  }
});

const onSsoClick = () => {
  if (lastSsoProvider.value) {
    const { from = '' } = router.currentRoute.value.query || {};
    redirectToSsoProvider({
      from,
      provider: lastSsoProvider.value,
      isGoogle: lastSsoIsGoogle.value,
      isMicrosoft: lastSsoIsMicrosoft.value,
    });
    return;
  }

  emit('toggleSso');
};
</script>

<style scoped lang="less">
.sso-button:deep(.v-btn__content) {
  overflow: hidden;
  text-transform: initial;
  font-size: 16px;
}
</style>
